{
  "name": "gps",
  "version": "1.78.1",
  "engines": {
    "node": ">=18.0.0",
    "npm": "^8.0.0"
  },
  "scripts": {
    "start": "ng serve --disable-host-check --open",
    "start:debug": "ng serve --disable-host-check --open --source-map --optimization=false --verbose",
    "serve:local": "ng serve --disable-host-check --source-map",
    "serve:local:debug": "ng serve --disable-host-check --source-map --optimization=false --verbose --poll=2000",
    "serve:dev": "ng serve --configuration=dev --disable-host-check",
    "serve:preprod": "ng serve --configuration=preprod --disable-host-check",
    "serve:prod": "ng serve --configuration=prod --disable-host-check",
    "build": "npm run build:prod && npm run build:preprod && npm run build:dev",
    "build:prod": "ng build --configuration=prod && gzipper compress --verbose ./dist/prod",
    "build:preprod": "ng build --configuration=preprod && gzipper compress --verbose ./dist/preprod",
    "build:preview": "ng build --configuration=preview && gzipper compress --verbose ./dist/preview",
    "build:dev": "ng build --configuration=dev && gzipper compress --verbose ./dist/dev",
    "build:analyze": "ng build --stats-json && webpack-bundle-analyzer dist/gps/stats.json",
    "test": "ng test --browsers=Chrome",
    "test:debug": "ng test --browsers=Chrome --watch --source-map --code-coverage",
    "test:coverage-watch": "ng test --browsers=Chrome --code-coverage --watch",
    "test:coverage": "ng test --browsers=Chrome --code-coverage",
    "test:ci": "ng test --code-coverage --no-watch --no-progress --source-map=false --karma-config=ci.karma.conf.js",
    "test:watch": "ng test --browsers=Chrome --watch",
    "lint": "ng lint && npm run lint:styles",
    "lint:fix": "ng lint --fix && npm run lint:styles --fix",
    "lint:styles": "stylelint \"src/**/*.scss\"",
    "clean": "rm -rf node_modules dist .angular && npm cache clean --force",
    "clean:install": "npm run clean && npm install",
    "prepare": "is-ci || husky install",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "analyze": "ng build --stats-json && webpack-bundle-analyzer dist/gps/stats.json",
    "cy:run": "cypress run",
    "cy:open": "cypress open",
    "e2e": "concurrently \"npm run serve:local\" \"npm run cy:run\"",
    "e2e:open": "concurrently \"npm run serve:local\" \"npm run cy:open\"",
    "e2e:ci:dev": "start-server-and-test serve:dev http://localhost:4200 cy:run",
    "e2e:ci:preprod": "start-server-and-test serve:preprod http://localhost:4200 cy:run",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc:serve": "compodoc -s",
    "release": "standard-version",
    "release:minor": "standard-version --release-as minor && bash release.sh",
    "release:patch": "standard-version --release-as patch && bash release.sh",
    "release:major": "standard-version --release-as major && bash release.sh",
    "commit": "npx cz",
    "debug:inspect": "ng serve --disable-host-check --source-map --optimization=false --verbose --poll=2000 --live-reload",
    "debug:memory": "node --max-old-space-size=8192 ./node_modules/@angular/cli/bin/ng serve --disable-host-check --source-map",
    "update:check": "npm outdated",
    "update:deps": "npm update && npm audit fix"
  },
  "config": {
    "commitizen": {
      "path": "@commitlint/cz-commitlint"
    }
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/build-angular": "^18.1.3",
    "@angular-material-components/file-input": "^7.0.0",
    "@angular/animations": "^18.1.3",
    "@angular/cdk": "^18.1.3",
    "@angular/common": "^18.1.3",
    "@angular/compiler": "^18.1.3",
    "@angular/core": "^18.1.3",
    "@angular/forms": "^18.1.3",
    "@angular/google-maps": "^18.1.3",
    "@angular/material": "^18.1.3",
    "@angular/platform-browser": "^18.1.3",
    "@angular/platform-browser-dynamic": "^18.1.3",
    "@angular/router": "^18.1.3",
    "@angular/service-worker": "^18.1.3",
    "@angular/youtube-player": "^18.1.3",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/effects": "^18.0.2",
    "@ngrx/entity": "^18.0.2",
    "@ngrx/router-store": "^18.0.2",
    "@ngrx/store": "^18.0.2",
    "@ngrx/store-devtools": "^18.0.2",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^7.100.0",
    "@sentry/tracing": "^7.100.0",
    "angular-oauth2-oidc": "^17.0.0",
    "dayjs": "^1.11.10",
    "gsap": "^3.12.2",
    "gzipper": "~7.2.0",
    "hammerjs": "2.0.8",
    "is-ci": "^3.0.1",
    "js-sha1": "^0.7.0",
    "marked": "^12.0.0",
    "ngrx-store-freeze": "^0.2.4",
    "rxjs": "^7.8.1",
    "transformation-matrix": "^2.16.1",
    "tslib": "^2.6.2",
    "zone.js": "~0.14.8"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^18.0.1",
    "@angular-eslint/eslint-plugin": "^18.0.1",
    "@angular-eslint/eslint-plugin-template": "^18.0.1",
    "@angular-eslint/schematics": "^18.0.1",
    "@angular-eslint/template-parser": "^18.0.1",
    "@angular/cli": "^18.1.3",
    "@angular/compiler-cli": "^18.1.3",
    "@angular/language-service": "^18.1.3",
    "@commitlint/cli": "^19.0.0",
    "@commitlint/config-conventional": "^19.0.0",
    "@commitlint/cz-commitlint": "^19.0.0",
    "@compodoc/compodoc": "^1.1.25",
    "@cypress/schematic": "^2.5.1",
    "@hirez_io/observer-spy": "^2.2.0",
    "@ngrx/eslint-plugin": "^18.0.2",
    "@ngrx/schematics": "^18.0.2",
    "@types/hammerjs": "^2.0.45",
    "@types/jasmine": "^5.1.4",
    "@types/marked": "^6.0.0",
    "@types/node": "^22.1.0",
    "@typescript-eslint/eslint-plugin": "^7.0.0",
    "@typescript-eslint/parser": "^7.0.0",
    "commitizen": "^4.3.0",
    "concurrently": "^8.2.2",
    "cypress": "^13.6.0",
    "eslint": "^8.57.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-airbnb-typescript": "^18.0.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.0.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-rxjs": "^5.0.3",
    "jasmine-core": "^5.1.1",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "standard-version": "^9.5.0",
    "start-server-and-test": "^2.0.3",
    "stylelint": "^16.0.0",
    "stylelint-config-prettier": "^9.0.5",
    "stylelint-config-recommended-scss": "^14.0.0",
    "stylelint-config-standard": "^36.0.0",
    "stylelint-scss": "^6.0.0",
    "ts-node": "^10.9.2",
    "typescript": "5.5.4",
    "webpack-bundle-analyzer": "^4.10.1"
  },
  "optionalDependencies": {
    "husky": "^9.0.0",
    "lint-staged": "^15.0.0",
    "prettier": "^3.2.0"
  }
}
